import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { getMethodsForTestId } from "../../../utils/getMethodsForTestId";
import styles from './FieldSubText.css';
var cx = classNames.bind(styles);
export var FieldSubText = function FieldSubText(_ref) {
  var invalid = _ref.invalid,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      errorIcon = _ref.errorIcon,
      namespace = _ref.namespace;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'fieldSubText'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root', classes === null || classes === void 0 ? void 0 : classes.root)
  }, getTestId()), /*#__PURE__*/React.createElement("div", {
    className: cx('inner', {
      invalid: invalid
    }, classes === null || classes === void 0 ? void 0 : classes.inner)
  }, invalid && /*#__PURE__*/React.createElement("span", {
    className: cx('icon', classes === null || classes === void 0 ? void 0 : classes.icon)
  }, errorIcon), /*#__PURE__*/React.createElement("p", {
    className: cx('text', classes === null || classes === void 0 ? void 0 : classes.text)
  }, children)));
};